import { formatMoney } from "utils";
import React, { useState } from "react";
import { api } from "services";

const Footer = ({id, account}) => {
    const [reportLoading, setReportLoading] = useState(false);  // State to manage report loading state

    // Handle report download based on user selection (Current Month, Lifetime, etc.)
    const handleDownload = (value) => {
        let startMonth = new Date();
        const endMonth = new Date();
        
        if (value === "Current Month") {
            startMonth.setDate(1);  // Start from the 1st of the current month
        } else if (value === "Lifetime") {
            startMonth = "lifetime";  // Set to 'lifetime' for lifetime report
        } else {
            const months = { "3 Months": 3, "6 Months": 6, "1 Year": 12 };
                startMonth.setMonth(endMonth.getMonth() - months[value]);  // Set start date based on selected range
                startMonth.setDate(startMonth.getDate() - 1);  // Adjust the start date for correct range
        }
        
        if (startMonth !== "lifetime") {
            setReportLoading(true);  // Show loader while generating the report
        }
        
        api.downloadMonthlyReport(id, startMonth, endMonth).then(() => {
            setReportLoading(false);  // Hide loader once the report is downloaded
        });
    };

    return (
        <div className="fixed-bottom w-100 bg-app py-2 px-3 text-white d-flex">
        <h3 className="my-auto text-left text-md-left col-8" title="Account Balance">
            Balance : 
            {
                account ? 
                <span className="fs-5">
                    <i>{formatMoney(account.get("balance"))}</i>
                </span> : ""
            }
        </h3>
        {account && (
            <div className="ms-auto col-2 d-flex">
            <div className="col-6 ms-auto text-end w-100">
                <div className="dropdown">
                <button className="btn btn-app btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                    <div className="d-flex align-items-center">
                    {reportLoading ?
                        <span className="spinner-border text-white" role="status" aria-hidden="true"></span> :
                        <i className="bi bi-file-earmark-arrow-down" style={{ fontSize: "2rem", color: "white" }} />}
                    </div>
                </button>
                {/* Dropdown menu for report options */}
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    {["Current Month", "3 Months", "6 Months", "1 Year", "Lifetime"].map((item, idx) => (
                    <li key={idx}>
                        <button className="dropdown-item" onClick={() => handleDownload(item)}>{item}</button>
                    </li>
                    ))}
                </ul>
                </div>
            </div>
            </div>
        )}
        </div>
    )
}

  export default Footer;